export const STEP_TRIP_DETAILS = {
  id: 'trip-details',
  label: 'Trip details',
  path: 'guests-dates',
};

export const STEP_YOUR_ACCOUNT = {
  id: 'account',
  label: 'Your account',
  path: 'signup',
};

/**
 * Package inquiry steps shown in the stepper.
 * Trip details is always first. Your account is included only while the
 * visitor is logged out, and it stays current after signup so the inquiry
 * can still be submitted.
 * The stepper itself is rendered only when this list has at least two steps.
 */
export const buildPackageInquirySteps = (hasCurrentUser, currentStepPath) => {
  const onAccountStep = currentStepPath === STEP_YOUR_ACCOUNT.path;
  const includeAccountStep = !hasCurrentUser || onAccountStep;
  const steps = [STEP_TRIP_DETAILS];

  if (includeAccountStep) {
    steps.push(STEP_YOUR_ACCOUNT);
  }

  return steps;
};

export const shouldShowInquiryStepper = steps => Array.isArray(steps) && steps.length >= 2;
